import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "./router.js";
import { App } from "./app.js";
import { AuthProvider } from "./auth.js";
import { LocaleProvider } from "./i18n.js";
import { RuntimeBrand } from "./runtime-brand.js";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <LocaleProvider>
        <AuthProvider>
          <RuntimeBrand />
          <App />
        </AuthProvider>
      </LocaleProvider>
    </BrowserRouter>
  </StrictMode>,
);
